export default "__VITE_ASSET__QdWsdHnT__"